export default {"src":"/_next/static/media/0x3095c7557bcb296ccc6e363de01b760ba031f2d9.684ff353.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};